const CapitanIcon = ({ width, height }) => {
    const defaultWidth = 17;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? defaultWidth}
            height={height ?? defaultWidth}
            viewBox="0 0 36 36"
        >
            <path fill="#CCD6DD" d="m24 29l5-5L6 1H1v5z" />
            <path fill="#9AAAB4" d="M1 1v5l23 23l2.5-2.5z" />
            <path
                fill="#D99E82"
                d="M33.424 32.808c.284-.284.458-.626.531-.968l-5.242-6.195l-.701-.702c-.564-.564-1.57-.473-2.248.205l-.614.612c-.677.677-.768 1.683-.204 2.247l.741.741l6.15 5.205c.345-.072.688-.247.974-.532l.613-.613z"
            />
            <path
                fill="#BF6952"
                d="M33.424 32.808c.284-.284.458-.626.531-.968l-1.342-1.586l-.737 3.684c.331-.077.661-.243.935-.518l.613-.612zm-3.31-5.506l-.888 4.441l1.26 1.066l.82-4.1zm-1.401-1.657l-.701-.702a1.2 1.2 0 0 0-.326-.224l-.978 4.892l1.26 1.066l.957-4.783l-.212-.249zm-2.401-.888a2.02 2.02 0 0 0-.548.392l-.614.611a1.981 1.981 0 0 0-.511.86c-.142.51-.046 1.035.307 1.387l.596.596l.77-3.846c0-.001 0-.001 0 0z"
            />
            <circle cx="33.25" cy="33.25" r="2.75" fill="#8A4633" />
            <path
                fill="#FFAC33"
                d="M29.626 22.324a1.033 1.033 0 0 1 0 1.462l-6.092 6.092a1.033 1.033 0 1 1-1.462-1.462l6.092-6.092a1.033 1.033 0 0 1 1.462 0z"
            />
            <circle cx="22.072" cy="29.877" r="1.75" fill="#FFAC33" />
            <circle cx="29.626" cy="22.323" r="1.75" fill="#FFAC33" />
            <circle cx="22.072" cy="29.877" r="1" fill="#FFCC4D" />
            <circle cx="29.626" cy="22.323" r="1" fill="#FFCC4D" />
            <path
                fill="#FFAC33"
                d="M33.903 29.342a.762.762 0 0 1 0 1.078l-3.476 3.475a.762.762 0 1 1-1.078-1.078l3.476-3.475a.762.762 0 0 1 1.078 0z"
            />
            <path fill="#CCD6DD" d="m12 29l-5-5L30 1h5v5z" />
            <path fill="#9AAAB4" d="M35 1v5L12 29l-2.5-2.5z" />
            <path
                fill="#D99E82"
                d="M2.576 32.808a1.946 1.946 0 0 1-.531-.968l5.242-6.195l.701-.702c.564-.564 1.57-.473 2.248.205l.613.612c.677.677.768 1.683.204 2.247l-.741.741l-6.15 5.205a1.946 1.946 0 0 1-.974-.532l-.612-.613z"
            />
            <path
                fill="#BF6952"
                d="M2.576 32.808a1.946 1.946 0 0 1-.531-.968l1.342-1.586l.737 3.684a1.932 1.932 0 0 1-.935-.518l-.613-.612zm3.31-5.506l.888 4.441l-1.26 1.066l-.82-4.1zm1.401-1.657l.701-.702a1.2 1.2 0 0 1 .326-.224l.978 4.892l-1.26 1.066l-.957-4.783l.212-.249zm2.401-.888c.195.095.382.225.548.392l.613.612c.254.254.425.554.511.86c.142.51.046 1.035-.307 1.387l-.596.596l-.769-3.847c0-.001 0-.001 0 0z"
            />
            <circle cx="2.75" cy="33.25" r="2.75" fill="#8A4633" />
            <path
                fill="#FFAC33"
                d="M6.374 22.324a1.033 1.033 0 0 0 0 1.462l6.092 6.092a1.033 1.033 0 1 0 1.462-1.462l-6.092-6.092a1.033 1.033 0 0 0-1.462 0z"
            />
            <circle cx="13.928" cy="29.877" r="1.75" fill="#FFAC33" />
            <circle cx="6.374" cy="22.323" r="1.75" fill="#FFAC33" />
            <circle cx="13.928" cy="29.877" r="1" fill="#FFCC4D" />
            <circle cx="6.374" cy="22.323" r="1" fill="#FFCC4D" />
            <path
                fill="#FFAC33"
                d="M2.097 29.342a.762.762 0 0 0 0 1.078l3.476 3.475a.762.762 0 1 0 1.078-1.078l-3.476-3.475a.762.762 0 0 0-1.078 0z"
            />
        </svg>
    );
};

export default CapitanIcon;
